import { Component, Mixins, Prop } from 'vue-property-decorator';
import PaginationMixin from '../../PaginationMixin';
import entriesQuery from '../../queries/suggestionsListEntries';
import { UtilMixin } from '../../UtilMixin';
import Pager from './pager.vue';
import SuggestionEntryCard from './suggestionEntryCard.vue';

@Component({ components: { SuggestionEntryCard, Pager } })
export default class SuggestionsListEntries extends Mixins(
  PaginationMixin,
  UtilMixin
) {
  @Prop() public suggestionsListId!: string;

  public readonly suggestionsQuery = entriesQuery;
  public selectedStates = ['ACCEPTED', 'REJECTED', 'CREATED'];
  public statesCheckboxOptions: any[] = [];

  public mounted() {
    this.statesCheckboxOptions = [
      {
        text: this.$t('components.shared.suggestions_list_entries.accepted'),
        value: 'ACCEPTED',
      },
      {
        text: this.$t('components.shared.suggestions_list_entries.rejected'),
        value: 'REJECTED',
      },
      {
        text: this.$t('components.shared.suggestions_list_entries.created'),
        value: 'CREATED',
      },
    ];
  }

  public get suggestionsQueryVariables() {
    return {
      suggestionsListId: this.suggestionsListId,
      status: this.selectedStates,
      first: this.first,
      last: this.last,
      after: this.after,
      before: this.before,
    };
  }
}
